import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { ConfiguracaoService } from './core/services/configuracao.service';
import { ClarityService } from './core/services/clarity.service';
import { ConsentService } from './core/services/consent.service';
import { GoogleTagService } from './core/services/google-tag.service';
import { LinkedInInsightService } from './core/services/linkedin-insight.service';
import { LocaleService } from './core/services/locale.service';
import { MetaPixelService } from './core/services/meta-pixel.service';
import { SeoService } from './core/services/seo.service';
import { XPixelService } from './core/services/x-pixel.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'Finder';
  avisoSenhaFraca = false;
  adiamentosRestantes = 0;
  adiandoSenha = false;
  avisoSenhaErro: string | null = null;
  showConsent = false;

  constructor(
    public readonly auth: AuthService,
    configuracao: ConfiguracaoService,
    private readonly router: Router,
    private readonly metaPixel: MetaPixelService,
    seo: SeoService,
    private readonly googleTag: GoogleTagService,
    private readonly xPixel: XPixelService,
    private readonly linkedInInsight: LinkedInInsightService,
    private readonly clarity: ClarityService,
    private readonly consent: ConsentService,
    private readonly locale: LocaleService,
  ) {
    this.locale.bootstrapFromUrl(this.router.url);
    seo.start();
    this.maybeStartAnalytics();
    configuracao.carregarEGuardarNoStorage(1);
    if (auth.getToken()) {
      auth.me().subscribe({
        next: () => this.aplicarPoliticaSenha(),
        error: () => auth.clear(),
      });
    }
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.locale.setFromUrl(event.urlAfterRedirects || event.url);
      this.aplicarPoliticaSenha();
    });
  }

  onConsentAccepted(): void {
    this.showConsent = false;
    this.startAnalytics();
  }

  alterarSenhaAgora(): void {
    this.avisoSenhaFraca = false;
    void this.router.navigateByUrl('/account/security');
  }

  deixarSenhaParaDepois(): void {
    if (this.adiandoSenha) {
      return;
    }
    this.adiandoSenha = true;
    this.avisoSenhaErro = null;
    this.auth.adiarSenhaFraca().subscribe({
      next: () => {
        this.adiandoSenha = false;
        this.avisoSenhaFraca = false;
      },
      error: (err) => {
        this.adiandoSenha = false;
        this.avisoSenhaErro = err?.error?.message ?? 'Não foi possível adiar a troca de senha.';
      },
    });
  }

  private maybeStartAnalytics(): void {
    if (this.consent.hasConsent()) {
      this.showConsent = false;
      this.startAnalytics();
      return;
    }
    this.showConsent = true;
  }

  private startAnalytics(): void {
    this.metaPixel.start();
    this.googleTag.start();
    this.xPixel.start();
    this.linkedInInsight.start();
    this.clarity.start();
  }

  private aplicarPoliticaSenha(): void {
    const policy = this.auth.user()?.password_policy;
    const url = this.router.url.split('?')[0];
    if (policy?.must_change && !url.startsWith('/account/security')) {
      void this.router.navigateByUrl('/account/security');
    }
    this.adiamentosRestantes = policy?.adiamentos_restantes ?? 0;
    this.avisoSenhaFraca = !!policy?.suggest_change && !url.startsWith('/account/security');
  }
}
